/* Presentation only: APO remains the owner of options, conditions and prices. */
(() => {
  const path = location.pathname;
  const isBed = /\/products\/pat-tapi/.test(path);
  const isSofa = /\/products\/(canapea|coltar)/.test(path);
  // This Composad bed has two supplier-confirmed exterior widths. Keep its
  // characteristic table aligned with its native size without altering prices.
  if (path === '/products/pat-espresso-90-200-cm-alb-lucios') {
    let espressoTimer;
    function updateEspressoDimensions() {
      espressoTimer = undefined;
      const selected = document.querySelector('main variant-picker input[type="radio"][data-fieldset-index="0"]:checked');
      const size = selected && selected.value.match(/^(90|120)\s*[×x]\s*200\b/);
      if (!size) return;
      const width = size[1] === '90' ? '95,8' : '125,8';
      document.querySelectorAll('main table tr').forEach(row => {
        const cells = row.querySelectorAll('td');
        if (cells.length !== 2 || cells[0].textContent.trim() !== 'Lățime (cm)') return;
        if (cells[1].textContent !== width) cells[1].textContent = width;
      });
    }
    function scheduleEspressoDimensions() {
      if (espressoTimer !== undefined) return;
      espressoTimer = setTimeout(updateEspressoDimensions, 40);
    }
    document.addEventListener('change', scheduleEspressoDimensions, true);
    new MutationObserver(scheduleEspressoDimensions).observe(document.querySelector('main') || document.body, {subtree:true, childList:true});
    updateEspressoDimensions();
    return;
  }
  if (!isBed && !isSofa) return;
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  const title = option => normalize(option.querySelector('.mw-label .mw-text--style-strong')?.textContent);
  const valuesOf = option => Array.from(option.querySelectorAll('.mw-option__value'));
  const familyOf = value => value?.querySelector('input')?.getAttribute('aria-label')?.match(/^(Casa|Vogue)\b/)?.[1];
  const bedOrder = ['Dimensiune', 'Tip somiera', 'Sistem de rabatare si depozitare', 'Saltea', 'Culoare', 'Picioare'];
  let timer;
  let observer;
  let pendingSelection;

  function rememberSofaSelection(event) {
    if (!isSofa || !(event.target instanceof HTMLInputElement) ||
      event.target.closest('.mw-apo-container') ||
      !event.target.closest('variant-picker, .globo-swatch-product-detail')) return;
    const selected = Array.from(document.querySelectorAll('.mw-apo-container .mw-option')).map(option => ({
      title: title(option),
      value: option.querySelector('input:checked')?.getAttribute('aria-label'),
    })).filter(option => option.value);
    if (selected.length) pendingSelection = { selected, path: location.pathname, expires: Date.now() + 10000 };
  }

  function restoreSofaSelection() {
    if (!pendingSelection) return;
    if (pendingSelection.path !== location.pathname || Date.now() > pendingSelection.expires) {
      pendingSelection = undefined;
      return;
    }
    // Replay only existing, enabled APO inputs. APO still applies its own
    // conditions and prices; incompatible or removed choices are never forced.
    const options = Array.from(document.querySelectorAll('.mw-apo-container .mw-option'));
    pendingSelection.selected.forEach(saved => {
      const option = options.find(node => title(node) === saved.title);
      const input = Array.from(option?.querySelectorAll('input[type="radio"]') || [])
        .find(node => node.getAttribute('aria-label') === saved.value);
      const value = input?.closest('.mw-option__value');
      if (input && !input.checked && !input.disabled && value?.getClientRects().length) input.click();
    });
  }

  function refresh() {
    restoreSofaSelection();
    document.querySelectorAll('.mw-apo-container').forEach(root => {
      const options = Array.from(root.children).filter(node => node.matches('.mw-option'));
      if (isBed) {
        const rank = option => {
          const index = bedOrder.indexOf(title(option));
          return index < 0 ? bedOrder.length : index;
        };
        const ordered = [...options].sort((a, b) => rank(a) - rank(b));
        ordered.forEach((option, index) => {
          const current = Array.from(root.children).filter(node => node.matches('.mw-option'));
          if (current[index] !== option) root.insertBefore(option, current[index]);
        });
      }
      if (!isSofa) return;
      const colors = options.find(option => title(option) === 'Culoare tapiterie');
      if (!colors || options.some(option => title(option) === 'Gama tapiterie')) return;
      const values = valuesOf(colors);
      const families = [...new Set(values.map(familyOf).filter(Boolean))];
      // Do not hide fabrics if a supplier palette cannot be classified completely.
      if (families.length !== 2 || !values.every(value => familyOf(value))) return;
      let picker = root.querySelector('[data-italflex-fabric-family]');
      if (!picker) {
        picker = document.createElement('fieldset');
        picker.className = 'italflex-family-picker';
        picker.dataset.italflexFabricFamily = 'true';
        const legend = document.createElement('legend');
        legend.textContent = document.querySelector('[data-italflex-configurator-labels]')?.dataset.familyLabel || 'Gamă tapițerie';
        picker.append(legend);
        families.forEach(name => {
          const label = document.createElement('label');
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = 'italflex_fabric_family_ui';
          input.value = name;
          input.addEventListener('change', () => {
            // APO can replace its palette when a native variant changes.
            // Resolve the live node instead of retaining the old palette.
            const liveColors = Array.from(root.children).find(node =>
              node.matches('.mw-option') && title(node) === 'Culoare tapiterie');
            if (!liveColors) return;
            const currentValues = valuesOf(liveColors);
            const current = currentValues.find(value => value.querySelector('input')?.checked);
            if (familyOf(current) !== name) {
              const next = currentValues.find(value => familyOf(value) === name && !value.querySelector('input')?.disabled);
              next?.querySelector('input')?.click();
            }
            refresh();
          });
          label.append(input, document.createTextNode(name));
          picker.append(label);
        });
        colors.before(picker);
      }
      const selected = familyOf(values.find(value => value.querySelector('input')?.checked)) || families[0];
      picker.querySelectorAll('input').forEach(input => { input.checked = input.value === selected; });
      values.forEach(value => { value.hidden = familyOf(value) !== selected; });
    });
    if (isSofa && /\/canapea-extensibila-cu-saltea-(modena|parma)$/.test(path)) {
      const variants = document.querySelector('.globo-swatch-product-detail');
      const labels = document.querySelector('[data-italflex-configurator-labels]');
      if (variants && labels?.dataset.fixedDimensions && !document.querySelector('[data-italflex-fixed-dimension]')) {
        const note = document.createElement('p');
        note.dataset.italflexFixedDimension = 'true';
        note.className = 'italflex-fixed-dimension';
        note.textContent = labels.dataset.fixedDimensions;
        variants.before(note);
      }
    }
  }
  function schedule() {
    if (timer) return;
    timer = setTimeout(() => { timer = undefined; refresh(); }, 100);
  }
  function start() {
    observer?.disconnect();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    schedule();
  }
  window.addEventListener('change', rememberSofaSelection, true);
  document.addEventListener('click', event => {
    if (event.isTrusted && event.target instanceof HTMLElement &&
      event.target.closest('.mw-apo-container, [data-italflex-fabric-family]')) pendingSelection = undefined;
  }, true);
  document.addEventListener('keydown', event => {
    if (event.isTrusted && [' ', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key) &&
      event.target instanceof HTMLElement &&
      event.target.closest('.mw-apo-container, [data-italflex-fabric-family]')) pendingSelection = undefined;
  }, true);
  document.addEventListener('change', schedule, true);
  window.addEventListener('pagehide', () => { observer?.disconnect(); clearTimeout(timer); timer = undefined; });
  window.addEventListener('pageshow', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
